import { render, staticRenderFns } from "./Koriklar.vue?vue&type=template&id=24903cdd&scoped=true"
import script from "./Koriklar.vue?vue&type=script&lang=js"
export * from "./Koriklar.vue?vue&type=script&lang=js"
import style0 from "./Koriklar.vue?vue&type=style&index=0&id=24903cdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24903cdd",
  null
  
)

export default component.exports